var ChangeCompanyStateModalController = /** @class */ (function () {
    function ChangeCompanyStateModalController() {
        // this.companyInfo = this.resolve.companyInfo;
        // this.changeToState = this.resolve.changeToState;
    }
    ChangeCompanyStateModalController.prototype.$onInit = function () {
        this.companyInfo = this.resolve.companyInfo;
        this.changeToState = this.resolve.changeToState;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    ChangeCompanyStateModalController.prototype.onCompanyDelete = function () {
        this.callbackObject.callbackType = 'delete';
        this.closeModal();
    };
    ChangeCompanyStateModalController.prototype.onStateChange = function () {
        this.callbackObject.callbackType = 'stateChange';
        this.closeModal();
    };
    ChangeCompanyStateModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    ChangeCompanyStateModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return ChangeCompanyStateModalController;
}());
// import * as TEMPLATE from './change-company-state-modal.html';
import * as TEMPLATE from 'raw-loader!./change-company-state-modal.html';
export var ChangeCompanyStateModalComponent = {
    selector: 'changeCompanyStateModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: ChangeCompanyStateModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/changeCompanyStateModal/change-company-state-modal.html'
    }
};
//# sourceMappingURL=change-company-state-modal.component.js.map